import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const COMPONENT_SPLITTER_CONFIG = {
    type: ERFElement.ComponentSplitter,
    icon: 'ComponentSplitter_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Входной поток',
                    position: Position.Left,
                    style: { top: 35, left: 19, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_flow_product_1',
                    type: 'source',
                    name: 'Продукт 1',
                    position: Position.Top,
                    style: { top: 9, left: 35, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_liquid_flow_product_2',
                    type: 'source',
                    name: 'Продукт 2',
                    position: Position.Bottom,
                    style: { bottom: 25, left: 35, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 62, left: 19, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 62, right: 21, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFComponentSplitterNode.config.js.map